import { render, staticRenderFns } from "./videoPreview.vue?vue&type=template&id=0f48aeda&scoped=true&"
import script from "./videoPreview.vue?vue&type=script&lang=js&"
export * from "./videoPreview.vue?vue&type=script&lang=js&"
import style0 from "./videoPreview.vue?vue&type=style&index=0&id=0f48aeda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48aeda",
  null
  
)

export default component.exports